const aboutData = {
    name: "Thomas Pettersen",
    email: "ThomasPettersen20@gmail.com",
    bio: "I am a Software Engineer who excels in problem solving. Through my experience as a coding instructor, I possess a strong ability to communicate technical concepts. I’m also experienced in cross-industry collaboration, leading complex projects with cross-functional teams. I’m skilled in product lifecycle management through founding, scaling, and operating a product sales business, coordinating sales, operations and project management.",
    languages: ["JavaScript", "Python", "HTML", "CSS", "SQL", "EJS"],
    frameworks: ["React", "Express.js", "Django", "Bootstrap", "Mongoose"],
    databases: ["MongoDB", "PostgreSQL"],
    other: ["Node.js", "Git", "Postman"]
}

export { aboutData }